import React, { useEffect, useState, useRef } from 'react';
import propTypes from 'prop-types';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { setBreadcrumbs, InnerLoader } from 'src/ui';
import { fetchLoggedInUser, getUser } from 'src/user';

import { getToken } from 'src/auth';
import { connect } from 'react-redux';
import { fetchAccount, getAccount } from 'src/account';
import moment from 'moment';
import { fetchInsuranceLogs, getInsuranceLogs } from '../redux';
import { UiDateRangePicker } from '../../ui';
import { InsuranceLogTable } from '../components';

function InsuranceLogsListPage({
  user,
  token,
  fetchInsuranceLogs,
  insuranceLogs,
  setBreadcrumbs,
}) {
  const now = new Date();
  const today = moment(
    new Date(now.getFullYear(), now.getMonth(), now.getDate())
  );
  const startDate = today.clone().subtract(14, 'days');
  const endDate = today
    .clone()
    .add(1, 'days')
    .subtract(1, 'seconds');
  const [dateRange, setDateRange] = React.useState([
    startDate.toDate(),
    endDate.toDate(),
  ]);
  const [loading, setLoading] = useState(true);
  const isFirstRun = useRef(0);
  useEffect(() => {
    (async () => {
      isFirstRun.current += 1;

      setBreadcrumbs([{ label: 'Insurance Logs', href: '/insurance-logs' }]);
      if (token.isValid()) {
        await fetchInsuranceLogs({
          fiId: user.financialInstitutionId,
          start: dateRange[0],
          end: dateRange[1],
        });
        setLoading(false);
      }
    })();
  }, []);
  useEffect(() => {
    (async () => {
      isFirstRun.current += 1;
      setLoading(true);
      if (isFirstRun.current > 2) {
        await fetchInsuranceLogs({
          fiId: user.financialInstitutionId,
          start: dateRange[0],
          end: dateRange[1],
        });
      }

      if (!insuranceLogs.isLoading()) {
        setLoading(false);
      }
    })();
  }, [dateRange]);
  return (
    <>
      <Columns>
        <Column>
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Insurance Logs
          </MuiTitle>
        </Column>
        <Column>
          <div className="is-pulled-right">
            <UiDateRangePicker
              start={dateRange[0]}
              end={dateRange[1]}
              onChange={(start, end) => {
                setDateRange([start, end]);
              }}
            />
          </div>
        </Column>
      </Columns>
      {!loading && !insuranceLogs.isLoading() ? (
        <InnerInsuranceLogsListPage
          data={insuranceLogs.insuranceLogs}
          loading={loading}
        />
      ) : (
        <InnerLoader visible />
      )}
    </>
  );
}
function InnerInsuranceLogsListPage({ data, loading }) {
  return (
    <>
      <InsuranceLogTable data={data} loading={loading} />
    </>
  );
}
function mapStateToProps(state) {
  return {
    user: getUser(state),
    token: getToken(state),
    account: getAccount(state),
    insuranceLogs: getInsuranceLogs(state),
  };
}
InsuranceLogsListPage.propTypes = {
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchInsuranceLogs: propTypes.func.isRequired,
  insuranceLogs: propTypes.object.isRequired,
};

InnerInsuranceLogsListPage.propTypes = {
  data: propTypes.array.isRequired,
  loading: propTypes.bool.isRequired,
};
const connectedInsuranceLogsListPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchInsuranceLogs,
  fetchLoggedInUser,
  fetchAccount,
})(InsuranceLogsListPage);

export { connectedInsuranceLogsListPage as InsuranceLogsListPage };
